var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4457 5.33435C4.50369 5.33435 5.36351 6.17498 5.36351 7.20935V14.125C5.36351 15.1594 4.50369 16 3.4457 16C2.38771 16 1.52789 15.1594 1.52789 14.125V7.20935C1.52789 6.17185 2.38451 5.33435 3.4457 5.33435Z",
    fill: "#E09200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66213 0C9.72012 0 10.5799 0.840625 10.5799 1.875V14.125C10.5799 15.1594 9.72012 16 8.66213 16C7.60414 16 6.74432 15.1594 6.74432 14.125V1.875C6.74432 0.840625 7.60414 0 8.66213 0Z",
    fill: "#E09200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8786 10.6656C14.9366 10.6656 15.7964 11.5063 15.7964 12.5406V14.125C15.7964 15.1594 14.9366 16 13.8786 16C12.8206 16 11.9608 15.1594 11.9608 14.125V12.5406C11.9608 11.5063 12.8206 10.6656 13.8786 10.6656Z",
    fill: "#E09200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.183771df14b2e6ae1890e07a32f0d665.svg";
export { ForwardRef as ReactComponent };